"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_polyglot_1 = require("react-polyglot");
const constants_1 = require("configs/constants");
const mobx_react_1 = require("mobx-react");
const node_polyglot_1 = __importDefault(require("node-polyglot"));
const en_json_1 = __importDefault(require("transifex/languages/en.json"));
const pt_BR_json_1 = __importDefault(require("transifex/resources/pt_BR.json"));
const ptPolyglot = new node_polyglot_1.default({ locale: constants_1.LOCALES.PT_BR, phrases: pt_BR_json_1.default });
const enPolyglot = new node_polyglot_1.default({ locale: constants_1.LOCALES.EN, phrases: en_json_1.default });
const mapStateToProps = (stores) => ({
    locale: stores.UserStore.locale,
    localeKeys: stores.UserStore.localeKeys
});
const Locale = ({ children, locale, localeKeys }) => {
    (0, react_1.useEffect)(() => {
        const handleMissingKey = (key, options) => {
            if (!key) {
                return '';
            }
            return (enPolyglot.t(key, options) ||
                ptPolyglot.t(key, options) ||
                `$i18n.${key}`);
        };
        node_polyglot_1.default.allowMissing = true;
        node_polyglot_1.default.onMissingKey = handleMissingKey;
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_polyglot_1.I18n, { locale: locale, messages: localeKeys, children: children }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(Locale);
